import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { Box, RadioGroup, Stack, Paper, Button } from "@mui/material";
import { useEffect, useState } from "react";
import fetcher from "../../../../dataProvider";
import { setExamRulesData } from "../../../../redux/slices/examDetails";
import { useAppDispatch, useAppSelector } from "../../../../redux/store";
import { stepCancelProps } from "../../../../types/common";
import getCandidateDetailsJson from "../../../../utils/getCandidateDetailJson";
import OrderCard from "../../../common/Card";
import styles from "./styles";
import {
  setLoading,
  setToastData,
} from "../../../../redux/slices/customerJourney";
import { getCountryId, getLanguageCode } from "../../../../utils/common";
import { useNavigate } from "react-router-dom";
import Popup from "../../../common/Modal";
import PaymentCard, {
  PaymentCardTextBox,
  PaymentCardTextPaper,
} from "./PaymentCard";
import CandidateSummary from "../../../common/CandidateSummary";
import usePageView from "../../../../utils/analytics/usePageView";
import GTM from "../../../../utils/analytics/gtm";

const Confimation = (props: stepCancelProps) => {
  usePageView("Confirm & Register");
  const { toggleSteps } = props;
  const examDataStore = useAppSelector((state) => state.examDetails);
  const customerJourney = useAppSelector((state) => state.customerJourney);
  const { pageText, countryList } = customerJourney;
  const { examRulesData } = examDataStore;
  const dispatch = useAppDispatch();
  const [paymentMode, setPaymentMode] = useState("");
  const [examDetails, setExamDetails] = useState<any>(null);
  const [lookupData, setLookupData] = useState<any>();
  const [candidateDetails, setCandidateDetails] = useState<any>(null);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let data: any = sessionStorage.getItem("examDetails");
    let examRules: any = sessionStorage.getItem("examRulesData");
    let candidateDetails: any = sessionStorage.getItem("candidateDetails");
    data = JSON.parse(data);
    examRules = JSON.parse(examRules);
    candidateDetails = JSON.parse(candidateDetails);
    setExamDetails(data);
    setCandidateDetails(candidateDetails);
    dispatch(setExamRulesData({ details: examRules }));
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  const getAppUrl = () => {
    const { protocol, host } = window.location;
    return `${protocol}//${host}`;
  };

  const fetchPayament = async (id: string) => {
    dispatch(setLoading({ loading: true }));
    try {
      const appUrl = getAppUrl();
      const body = {
        PaymentFinishUrl: `${appUrl}/rex-cj/candidateRegistered`,
      };
      const { data } = await fetcher.post(
        `api/processpayment/${id}/payments`,
        body
      );
      dispatch(setLoading({ loading: false }));
      if (data) {
        GTM.addPaymentInfo(examDetails, "online");
        window.location.href = data?.paymentFinishUrl;
      }
    } catch (e) {
      dispatch(setLoading({ loading: false }));
      console.log("error", e);
    }
  };

  const toggleRegistration = async (type = "online") => {
    dispatch(setLoading({ loading: true }));
    const countryId = getCountryId(countryList);
    const body = getCandidateDetailsJson(
      candidateDetails,
      type === "online" ? 1 : 0,
      countryId?.idValue
    );
    try {
      const { data } = await fetcher.post("/api/candidate", body);
      dispatch(setLoading({ loading: false }));
      if (data && data !== "00000000-0000-0000-0000-000000000000") {
        sessionStorage.setItem("candidateGuid", data);
        if (type === "online") {
          fetchPayament(data);
        } else {
          GTM.addPaymentInfo(examDetails, "offline");
          navigate("/rex-cj/candidateRegistered");
        }
      } else {
        dispatch(
          setToastData({
            toastData: {
              message:
                "Please use different name and DOB with these details you already registered",
              open: true,
              type: "failure",
            },
          })
        );
      }
    } catch (e) {
      dispatch(setLoading({ loading: false }));
      console.log("error", e);
    }
  };

  const getLookupData = async () => {
    dispatch(setLoading({ loading: true }));
    try {
      const countryId = getCountryId(countryList);
      let languageCode = getLanguageCode();
      if (languageCode && countryId) {
        const { data } = await fetcher.get(
          `/api/LookupData/GetLookupData?languageCode=${languageCode}`
        );
        setLookupData(data);
      }
      // dispatch(setLoading({ loading: false }));
    } catch (e) {
      dispatch(setLoading({ loading: false }));
      console.log("Error ", e);
      dispatch(
        setToastData({
          toastData: {
            message: pageText?.labelsMetadata?.somethingwrong,
            open: true,
            type: "failure",
          },
        })
      );
    }
  };

  const getExamRules = async () => {
    dispatch(setLoading({ loading: true }));
    try {
      let examData: any = sessionStorage.getItem("examDetails");
      examData = JSON.parse(examData);
      const countryId = getCountryId(countryList);
      let languageCode = getLanguageCode();
      if (languageCode && countryId) {
        const { data } = await fetcher.get(
          `/api/Exam/?languageCode=${languageCode}&id=${examData.examId}&alias=${countryId?.textValue}`
        );
        dispatch(setExamRulesData({ details: data }));
        sessionStorage.setItem("examRulesData", JSON.stringify(data));
      }
      dispatch(setLoading({ loading: false }));
    } catch (e) {
      console.log("Error ", e);
      dispatch(setLoading({ loading: false }));
      dispatch(
        setToastData({
          toastData: {
            message: pageText?.labelsMetadata?.somethingwrong,
            open: true,
            type: "failure",
          },
        })
      );
    }
  };

  useEffect(() => {
    if (pageText) {
      getExamRules();
      getLookupData();
    }
  }, [pageText]);

  const handleClose = () => {
    setOpen(false);
  };

  const showGuardianFields =
    candidateDetails?.age <
      examRulesData?.examRegistrationRules?.guardianAgeLimit &&
    examRulesData?.examRegistrationRules?.showGuardianFields;

  const onlineSelected = paymentMode === "online";
  const offlineSelected = paymentMode === "offline";

  return (
    <Stack
      mt={11}
      mb={10}
      direction={{ md: "row-reverse" }}
      justifyContent="space-between"
      gap={2}
    >
      <OrderCard examDetails={examDetails} />
      <Paper component={Box} p={{ xs: 2, md: 3 }} sx={styles.detailBox}>
        <Box className="label_head">
          {pageText?.textMetadata?.preferredpaymentmethodtext}
        </Box>
        <Box>
          <RadioGroup
            name="row-radio-buttons-group"
            onChange={(e: any) => {
              setPaymentMode(e.target.value);
            }}
          >
            {examRulesData?.hasOnlinePayment && (
              <PaymentCard
                value="online"
                selected={onlineSelected}
                topLabel={pageText?.paymentMetadata?.onlinePayment}
                selectedText={pageText?.textMetadata?.onlinepaymenttext}
                notSelectedText={
                  pageText?.textMetadata?.selectonlinecheckboxtext
                }
                priceLabel={pageText?.labelsMetadata.priceLabel}
                price={`${examDetails?.currencyCode} ${examDetails?.price}`}
                buttonText={pageText?.linksMetadata.paynowtext}
                onPay={() => {
                  const regex = /<([a-z1-6]+)\s*>\s*<\/\1>/i;
                  if (
                    !regex.test(
                      examRulesData?.onlinePaymentOptions?.instruction
                    )
                  ) {
                    toggleRegistration();
                  } else {
                    setOpen(true);
                  }
                }}
              >
                {examRulesData?.onlinePaymentOptions?.instruction && (
                  <PaymentCardTextPaper>
                    <Box>{pageText?.paymentMetadata?.onlinePaymentLabel}</Box>
                    <br></br>
                    <Box>
                      {pageText?.paymentMetadata?.acceptedPaymentMethods}
                    </Box>
                    <br></br>
                    <Box sx={{ fontWeight: "700" }}>
                      {examRulesData?.onlinePaymentOptions?.title}
                    </Box>
                    <PaymentCardTextBox
                      htmlText={
                        examRulesData?.onlinePaymentOptions?.instruction
                      }
                    />
                  </PaymentCardTextPaper>
                )}
              </PaymentCard>
            )}

            {examRulesData?.hasOfflinePayment && (
              <PaymentCard
                selected={offlineSelected}
                value="offline"
                topLabel={pageText?.paymentMetadata?.offlinePayment}
                selectedText={
                  pageText?.textMetadata?.youselectedanofflinepaymentmethod
                }
                notSelectedText={
                  pageText?.textMetadata?.selectofflinecheckboxtext
                }
                priceLabel={pageText?.labelsMetadata.priceLabel}
                price={`${examDetails?.currencyCode} ${examDetails?.price}`}
                buttonText={pageText?.textMetadata?.applynow}
                onPay={() => {
                  const regex = /<([a-z1-6]+)\s*>\s*<\/\1>/i;
                  if (
                    !regex.test(
                      examRulesData?.onlinePaymentOptions?.instruction
                    )
                  ) {
                    toggleRegistration("offline");
                  } else {
                    setOpen(true);
                  }
                }}
              >
                <PaymentCardTextPaper>
                  <Box>{pageText?.paymentMetadata?.offlinePaymentLabel}</Box>
                  <br></br>
                  <Box>{pageText?.paymentMetadata?.paymentInformation}</Box>
                  <br></br>
                  <Box>{pageText?.paymentMetadata?.howToPay}</Box>
                  <br></br>
                  <Box>{pageText?.paymentMetadata?.howToPayLabel}</Box>
                  <br></br>
                  <Box sx={{ fontWeight: "700" }}>
                    {
                      examRulesData?.offlinePaymentOptions?.paymentMethods[0]
                        ?.title
                    }
                  </Box>
                  <PaymentCardTextBox
                    htmlText={
                      examRulesData?.offlinePaymentOptions?.paymentMethods[0]
                        ?.instructions
                    }
                  />
                </PaymentCardTextPaper>
              </PaymentCard>
            )}
          </RadioGroup>
        </Box>

        <CandidateSummary
          pageText={pageText}
          candidateDetails={candidateDetails}
          examDetails={examDetails}
          lookupData={lookupData}
          examRulesData={examRulesData}
          showGuardianFields={showGuardianFields}
        />

        <Box className="top_divider" mt={2}></Box>

        <Stack direction={{ sm: "row" }} gap={2} py={2}>
          <Button
            variant="outlined"
            startIcon={<ArrowBackIosIcon />}
            onClick={() => toggleSteps("candidateData", 3)}
          >
            {pageText?.buttonsMetadata?.previousStep}
          </Button>
          <Button variant="text" onClick={() => toggleSteps("location", 0)}>
            {pageText?.buttonsMetadata?.cancelButtonText}
          </Button>
        </Stack>
      </Paper>

      <Popup open={open} handleClose={handleClose}>
        <Box>
          <Box sx={styles.modalBody}>
            <Box
              dangerouslySetInnerHTML={{
                __html: examRulesData?.onlinePaymentOptions?.instruction,
              }}
            ></Box>
          </Box>
          <Stack direction="row" justifyContent="center" gap={2}>
            <Button
              variant="contained"
              onClick={() => {
                paymentMode === "online"
                  ? toggleRegistration()
                  : toggleRegistration("offline");

                handleClose();
              }}
            >
              {pageText?.buttonsMetadata?.okButtonText}
            </Button>
            <Button variant="contained" onClick={handleClose}>
              {pageText?.buttonsMetadata?.cancelButtonText}
            </Button>
          </Stack>
        </Box>
      </Popup>
    </Stack>
  );
};

export default Confimation;
